function HamburgerIcon() {
    return <svg width="45px" height="30px" viewBox="0 0 51.64 37.06">
    <rect className="cls-1" width="51.64" height="2"/>
    <rect className="cls-1" y="35.06" width="51.64" height="2"/>
    <rect className="cls-1" y="17.53" width="51.64" height="2"/>
  </svg>
}

export default HamburgerIcon